export default __webpack_public_path__ + "static/media/Skill.83c79d0b.svg";